import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part7 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. SETTLEMENT MODEL */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            17. Settlement Model
                        </h1>

                        <div className="alert alert-info">
                            How and when funds actually move.
                        </div>

                        <h5 className="mt-4">Types</h5>

                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li><strong>Prefunded (balance-based)</strong></li>
                                <li><strong>Post-funded (T+N)</strong></li>
                                <li><strong>Ledger-only (internal)</strong></li>
                            </ul>
                        </div>

                        <div className="alert alert-warning mt-4">
                            Execution success ≠ settlement completion.
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 2. RECONCILIATION */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            18. Reconciliation
                        </h1>

                        <div className="alert alert-info">
                            Process of matching platform records, PSP records, and bank statements.
                        </div>

                        <div className="alert alert-secondary mt-4">
                            Reconciliation sources must be explicitly documented per PSP.
                        </div>

                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-six-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part VI
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-eight-doc">
                                                Part VIII &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>
                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}